export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID

export const pageView = (url: string) => {
  window.gtag?.('config', GA_TRACKING_ID, {
    page_path: url
  })
}

export const event = (action: string, params: Record<string, any>) => {
  window.gtag?.('event', action, params)
}
